import { useMutation } from "@tanstack/react-query";
import { resetMainDealerStepUpPassword } from "@/api/mainDealers";

export const useResetMainDealerStepUpPassword = () => {
  return useMutation({
    mutationFn: resetMainDealerStepUpPassword,
  });
};
